import { useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { showErrorMessage } from 'helpers/notifications';
import { CONFLICT, NOT_FOUND } from 'constants/statusErrors';
import { AddressResponse, convertResponseToAddress } from '@/types/mapbox';

export default function TablesConstructorPopup({ data, service, updateData, selectedCargoId, onClose, InfoComponent, searchCoordinates }) {
  const { t } = useTranslation();
  const authenticated = useSelector((state) => state.auth.authenticated);
  const lang = useSelector((state) => state.settings.lang);

  const [popupData, setPopupData] = useState(null);
  const [popupOpen, setPopupOpen] = useState(false);
  const [lastLoadedCargoId, setLastLoadedCargoId] = useState(null);

  const loadCargoData = useCallback(
    (cargoId) => {
      if (cargoId && cargoId !== lastLoadedCargoId) {
        setLastLoadedCargoId(cargoId);
        service
          .getById(cargoId, {
            lang,
          })
          .then((result) => {
            const data = result.data;
            const convertedData = {
              ...data,
              loading_address: convertResponseToAddress(data.loading_address),
              unloading_address: convertResponseToAddress(data.unloading_address),
              additional_loading_addresses: data.additional_loading_addresses?.length ? data.additional_loading_addresses.map((item: AddressResponse) => convertResponseToAddress(item)) : [],
              additional_unloading_addresses: data.additional_unloading_addresses?.length ? data.additional_unloading_addresses.map((item: AddressResponse) => convertResponseToAddress(item)) : [],
            };
            setPopupData(convertedData);
            setPopupOpen(true);
          })
          .catch((error) => {
            console.log('error', error);
            if (error.response.status === CONFLICT || error.response.status === NOT_FOUND) {
              showErrorMessage(t('errors.dealExist'));
            }
          });
      }
    },
    [service, lang, t, lastLoadedCargoId],
  );

  const handleClose = () => {
    setPopupOpen(false);
    setLastLoadedCargoId(null);
    if (onClose) {
      onClose(null);
    }
  };

  // Автоматически открываем попап если есть selectedCargoId
  useEffect(() => {
    if (selectedCargoId && authenticated) {
      // Load cargo data directly by ID, regardless of whether it's in the list
      loadCargoData(selectedCargoId);
    }
  }, [selectedCargoId, authenticated, loadCargoData]);

  return InfoComponent ? (
    <InfoComponent onClose={handleClose} data={popupData} updateData={updateData} isOpen={popupOpen} searchCoordinates={searchCoordinates} />
  ) : null;
}
